import { philanthropyParagraphs } from "@/mocks/home";
import { useReveal } from "@/hooks/useReveal";

const IMAGE =
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1440627814069-5OZS2UCSCVTEJKMVTOF8/harvestgarden.jpg?format=1500w";

export default function Philanthropy() {
  const { ref, visible } = useReveal<HTMLDivElement>();

  return (
    <section id="philanthropy" className="w-full bg-background-50 py-20 md:py-28">
      <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} w-full px-4 md:px-8`}>
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <p className="text-[11px] uppercase tracking-[0.32em] text-accent-600">In Our Communities</p>
            <h2 className="mt-4 font-heading font-light text-3xl md:text-5xl text-foreground-950">Philanthropy</h2>
            <div className="mt-7 space-y-5">
              {philanthropyParagraphs.map((p, i) => (
                <p key={i} className="text-[15px] leading-relaxed text-foreground-700">
                  {p}
                </p>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              {["Public Gardens", "Schools & Parks", "Care Facilities", "Native Habitat"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-4 py-1.5 text-xs tracking-wide text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative w-full h-[300px] md:h-[440px] lg:h-[520px] overflow-hidden rounded-lg">
              <img
                src={IMAGE}
                alt="Harvest Garden planting by club members"
                title="Harvest Garden"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="mt-3 text-xs text-foreground-500 tracking-wide">
              Hillsborough Beautification Foundation&rsquo;s Harvest Garden
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}